var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","depressed":"","color":"error"},on:{"click":_vm.handleButtonClick}},[_vm._v("\n  "+_vm._s(_vm.$t('asset_wise.disconnect'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33aa74d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/AssetWise/Management/Broker/DisconnectButton.vue
// module id = null
// module chunks = 